import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHandlingRequirementsCompare extends Layout {
	labelAddsAndDeletes: Label;
	labelChanges: Label;
	sourceEdiCompareAddDeleteItem: DataSource;
	sourceEdiCompareChangeItem: DataSource;
	tableHandlingRequirementAdd: Table;
	tableHandlingRequirementChange: Table;
}
